import axios from 'axios';
import { ApiError } from '../ApiError';
import { publicApi } from '../axios.config';
import { apiClient } from '../axios.interceptor';
import { API_ENDPOINTS, BASE_URL } from '../constants';

export const publicApiService = {
  // Public content
  getHomeContent: async () => {
    const response = await publicApi.get('/content/home');
    return response.data;
  },

  getBlogPosts: async (params?: { page?: number; limit?: number }) => {
    const response = await publicApi.get('/blog/posts', { params });
    return response.data;
  },

  getBlogPost: async (slug: string) => {
    const response = await publicApi.get(`/blog/posts/${slug}`);
    return response.data;
  },

  getProducts: async () => {
    const response = await publicApi.get('/products');
    return response.data;
  },

  contactUs: async (data: {
    name: string;
    email: string;
    message: string;
  }) => {
    const response = await publicApi.post('/contact', data);
    return response.data;
  },

  subscribeNewsletter: async (email: string) => {
    const response = await publicApi.post('/newsletter/subscribe', { email });
    return response.data;
  },

};

export const uploadFileToServer = async (file: File, _documentType: string): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("documentType", _documentType);

  try {
    const response = await apiClient.post(
      `${BASE_URL}${API_ENDPOINTS.UPLOAD_DOCUMENT}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.code !== 200) {
      return response;
    }

    const { fileUrl, fileKey, documentType, documentId }: any = response.data;
    return {
      code: response.code,
      fileUrl,
      fileKey,
      documentId,
      documentType,
    };
  } catch (error: any) {
    // Axios network error
    if (axios.isAxiosError(error)) {
      if (!error.response) {
        return {
          code: 500,
          data: null,
          message: "Internet disconnected or server not reachable",
        };
      } else {
        return {
          code: 500,
          data: null,
          message: error.response.data?.message || "Server error",
        };
      }
    }
    return {
      code: 500,
      data: null,
      message: error.message || "Unknown error occurred",
    };
  }
};